import React from 'react';

export const PanalytSuperAdminContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return <>{children}</>;
};
